
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"6.211","height":"6.743"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_44934","data-name":"Group 44934","transform":"translate(-1429.791 -492.497)","fill":"none","stroke":"#5856f9","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"1"}},[_c('path',{attrs:{"id":"Path_2","data-name":"Path 2","d":"M0 0l2.665 2.5L5.33 0","transform":"rotate(-90 964.516 -465.983)"}}),_c('path',{attrs:{"id":"Path_2-2","data-name":"Path 2","d":"M0 0l2.665 2.5L5.33 0","transform":"rotate(-90 965.767 -467.234)"}})])])
          )
        }
      }
    